import { INotificationParameter } from "./notification-parameter";

/** Тип события уведомления. */
export enum NotificationSubscriptionType {
    /** Создана заявка. */
    OrderCreated = "order-created",

    /** Создана продажа. */
    SaleCreated = "sale-created",

    /** Заявка готова, но не выдана. */
    OrderAwaitingPickup = "order-awaiting-pickup",

    // /** Заявка назначена на пользователя. */
    // OrderAssigned = "order-assigned",
}

/** Подписка на уведомление. */
export interface INotificationSubscription {
    /** Тип события. */
    type: NotificationSubscriptionType;

    /** Дополнительные параметры подписки. */
    params?: INotificationParameter[];
}
